import React from 'react'
import { IAppTableColumnProps } from './AppTableColumn'
import { AppTableContext } from './AppTable'
import { AppInput, AppDate } from 'components/AppFormItem'

interface IProps extends IAppTableColumnProps {
	value?: any
	dataIndex?: number
}

export class AppTableEditItem extends React.Component<IProps> {
	doTableGridChangValue = (value: any, context: AppTableContext) => {
		let field = this.props.field || ''
		let dataIndex = this.props.dataIndex || 0

		if (this.props.editType === 'date') {
			value = value === '' ? null : new Date(value).toISOString()
		}

		context.updateData(dataIndex, field, value)
	}

	renderItem = (context: AppTableContext) => {
		switch (this.props.editType) {
			case 'number':
				return (
					<AppInput
						{...this.props}
						dataType="number"
						onChange={(value, text) => {
							this.doTableGridChangValue(value, context)
						}}
					/>
				)
			case 'date':
				return (
					<AppDate
						{...this.props}
						onChange={(value, text) => {
							this.doTableGridChangValue(text, context)
						}}
					/>
				)
			default:
				return (
					<AppInput
						{...this.props}
						onChange={(value, text) => {
							this.doTableGridChangValue(value, context)
						}}
					/>
				)
		}
	}

	render() {
		return <AppTableContext.Consumer>{this.renderItem}</AppTableContext.Consumer>
	}
}



// WEBPACK FOOTER //
// ./src/components/AppTable/AppTableEditItem.tsx